import React from "react";

const PrivacyContent = ({ sections }) => {
  return (
    <div className="space-y-10">
      {sections.map((section, idx) => (
        <section key={section.title} id={`section-${idx}`}>
          <h3 className="text-xl font-semibold text-indigo-800 mb-2">
            {section.title}
          </h3>
          <div className="text-gray-800 text-base leading-relaxed">
            {section.content}
          </div>
          {idx !== sections.length - 1 && (
            <div className="my-6 border-t border-gray-200" />
          )}
        </section>
      ))}
    </div>
  );
};

export default PrivacyContent;
